import { Pipe, PipeTransform } from "@angular/core";
import { EcapTranslateService, ShellDomainProvider } from "@ecap3/core";

@Pipe({
  name: "localizedDate",
  pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
  private translateNameArr: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  constructor(private translateService: EcapTranslateService) {
    this.translateNameArr.forEach((month, index) => {
      this.translateService
        .getTranslationObservabable(month.toUpperCase())
        .subscribe((val) => (this.translateNameArr[index] = val));
    });
  }

  transform(value: any, patten: any): any {
    let dateString;
    if (value) {
      let newDate = new Date(value);

      if (this.translateNameArr[newDate.getMonth()]) {
        if (patten === "MMM y") {
          dateString = `${this.translateNameArr[newDate.getMonth()].slice(
            0,
            3
          )} ${newDate.getFullYear()}`;
        } else if (patten === "dd-MM-yyyy") {
          if (ShellDomainProvider["api"]["dotBehindDate"]) {
            dateString = `${newDate.getDate()}${
              ShellDomainProvider["api"]["dotBehindDate"]
            } ${this.translateNameArr[newDate.getMonth()].slice(
              0,
              3
            )} ${newDate.getFullYear()}`;
          } else {
            dateString = `${newDate.getDate()} ${this.translateNameArr[
              newDate.getMonth()
            ].slice(0, 3)} ${newDate.getFullYear()}`;
          }
        } else if (patten === "MMMM, yyyy") {
          dateString = `${
            this.translateNameArr[newDate.getMonth()]
          } ${newDate.getFullYear()}`;
        } else if (patten === "dd-mm-yyyy-hr-mt-sec") {
          const minutes = newDate.getMinutes();
          const seconds = newDate.getSeconds();
          dateString = `${newDate.getDate()} ${this.translateNameArr[
            newDate.getMonth()
          ].slice(0, 3)} ${newDate.getFullYear()}, ${newDate.getHours()}:${
            minutes < 10 ? `0${minutes}` : minutes
          }:${seconds < 10 ? `0${seconds}` : seconds}`;
        } else if (patten === "time,dd MMM yyyy") {
          let time = newDate.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
          });
          dateString = `${time}, ${newDate.getDate()} ${this.translateNameArr[
            newDate.getMonth()
          ].slice(0, 3)} ${newDate.getFullYear()}`;
        } else if (patten === "dd MMM") {
          dateString = `${newDate.getDate()} ${this.translateNameArr[
            newDate.getMonth()
          ].slice(0, 3)}`;
        } else if (patten === "MMM dd") {
          dateString = `${this.translateNameArr[newDate.getMonth()].slice(
            0,
            3
          )} ${newDate.getDate()}`;
        } else if (patten === "yyyy") {
          dateString = `${newDate.getFullYear()}`;
        } 
        else {
          if (ShellDomainProvider["api"]["dotBehindDate"]) {
            dateString = `${newDate.getDate()}${
              ShellDomainProvider["api"]["dotBehindDate"]
            } ${
              this.translateNameArr[newDate.getMonth()]
            } ${newDate.getFullYear()}`;
          } else {
            dateString = `${newDate.getDate()} ${
              this.translateNameArr[newDate.getMonth()]
            } ${newDate.getFullYear()}`;
          }
        }
      } else {
        dateString = newDate;
      }
    }
    return dateString;
  }
}
